(function (win) {
    'use strict';
    var fp = (win.fp = typeof win.fp !== 'undefined' ? win.fp : {}),
        home = (fp.home = typeof fp.home !== 'undefined' ? fp.home : {});

    // =========================================
    // Lazy Load Slideshow
    // =========================================
    const lazyLoadSlideshow = () => {
        document.querySelectorAll('.cycle-slideshow img[data-src]').forEach((img) => {
            img.setAttribute('src', img.getAttribute('data-src'));
            img.setAttribute('srcset', img.getAttribute('data-srcset'));
            img.setAttribute('sizes', img.getAttribute('data-sizes'));
            img.onload = () => {
                img.removeAttribute('data-src');
                img.removeAttribute('data-srcset');
                img.removeAttribute('data-sizes');
            };
        });
    };

    // =========================================
    // Setup Video Controls
    // =========================================
    const setupVideoControls = () => {
        const video = document.getElementById('bg-video');
        const videoButton = document.getElementById('video-pause-play');
        const videoButtonIcon = videoButton ? videoButton.querySelector('span') : null;
        const controlAnnouncements = document.getElementById('video-control-announcements');

        if (!video || !videoButton || !videoButtonIcon || !controlAnnouncements) return;

        videoButton.addEventListener('click', () => {
            if (!video.paused) {
                video.pause();
                videoButton.setAttribute('aria-label', 'Play video');
                videoButtonIcon.classList.replace('icon-pause', 'icon-play');
                controlAnnouncements.textContent = 'Video paused';
            } else {
                video.play();
                videoButton.setAttribute('aria-label', 'Pause video');
                videoButtonIcon.classList.replace('icon-play', 'icon-pause');
                controlAnnouncements.textContent = 'Video playing';
            }
        });
    };

    // =========================================
    // Setup Carousel Controls
    // =========================================
    const setupCarouselControls = () => {
        const carouselWrapper = document.querySelector('.slideshow');
        const carouselTarget = document.querySelector('.cycle-slideshow');
        const ariaLiveRegion = document.querySelector('#control-announcements');

        // Ensure the carousel target exists and the cycle plugin is available
        if (!carouselTarget || typeof $.fn.cycle !== 'function') return;

        // Initialize the carousel
        $(carouselTarget).cycle();

        // Pause the carousel on mouseenter
        if (carouselWrapper) {
            carouselWrapper.addEventListener('mouseenter', () => {
                if (!carouselTarget.classList.contains('hard-pause')) {
                    $(carouselTarget).cycle('pause');
                }
            });

            carouselWrapper.addEventListener('mouseleave', () => {
                if (!carouselTarget.classList.contains('hard-pause')) {
                    $(carouselTarget).cycle('resume');
                }
            });
        }

        // Handle the play/pause button
        const cyclePausePlay = document.querySelector('#cycle-pause-play');
        const cyclePausePlayIcon = cyclePausePlay ? cyclePausePlay.querySelector('span') : null;

        if (cyclePausePlay) {
            cyclePausePlay.addEventListener('click', function () {
                const isPaused = carouselTarget.classList.contains('hard-pause');

                // Update play/pause state
                if (isPaused) {
                    carouselTarget.classList.remove('hard-pause');
                    this.setAttribute('aria-label', 'Pause carousel');
                    if (cyclePausePlayIcon) {
                        cyclePausePlayIcon.classList.replace('icon-play', 'icon-pause');
                    }
                    ariaLiveRegion.textContent = 'Carousel is playing.';
                    $(carouselTarget).cycle('resume');
                } else {
                    carouselTarget.classList.add('hard-pause');
                    this.setAttribute('aria-label', 'Play carousel');
                    if (cyclePausePlayIcon) {
                        cyclePausePlayIcon.classList.replace('icon-pause', 'icon-play');
                    }
                    ariaLiveRegion.textContent = 'Carousel is paused.';
                    $(carouselTarget).cycle('pause');
                }
            });
        }

        // Handle the "Back" button
        const cycleBack = document.querySelector('#cycle-back');
        if (cycleBack && ariaLiveRegion) {
            cycleBack.addEventListener('click', () => {
                ariaLiveRegion.textContent = 'Reading previous slide.';
            });
        }

        // Handle the "Next" button
        const cycleNext = document.querySelector('#cycle-next');
        if (cycleNext && ariaLiveRegion) {
            cycleNext.addEventListener('click', () => {
                ariaLiveRegion.textContent = 'Reading next slide.';
            });
        }
    };

    // =========================================
    // Size Detector
    // =========================================
    const sizeDetector = () => {
        const root = document.documentElement;

        const setCSSVariable = (varName, value) => {
            root.style.setProperty(varName, `${value}px`);
        };

        const header = document.querySelector('header');
        setCSSVariable('--header-height', header ? header.offsetHeight : 0);

        const logoMobile = document.querySelector('#logo-mobile');
        setCSSVariable('--logo-mobile-height', logoMobile ? logoMobile.offsetHeight : 0);

        const utility = document.querySelector('#utility');
        setCSSVariable('--utility-height', utility ? utility.offsetHeight : 0);

        const specialMessage = document.querySelector('#special-message.message-banner');
        setCSSVariable(
            '--special-message-height',
            specialMessage && getComputedStyle(specialMessage).display !== 'none' ? specialMessage.offsetHeight : 0
        );

        const stickyFooter = document.querySelector('#ao-sticky');
        setCSSVariable(
            '--sticky-footer-height',
            stickyFooter && getComputedStyle(stickyFooter).display !== 'none' ? stickyFooter.offsetHeight : 0
        );
    };

    // =========================================
    // Debounce Function
    // =========================================
    const debounce = (func, delay) => {
        let timeoutId;
        return function (...args) {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => func.apply(this, args), delay);
        };
    };

    // Debounced version of sizeDetector for resize events
    const debouncedResizeHandler = debounce(sizeDetector, 250);

    window.addEventListener('resize', debouncedResizeHandler);

    // =========================================
    // Initialize Functions on Load
    // =========================================
    window.addEventListener('load', () => {
        setTimeout(sizeDetector, 250);
    });

    // =========================================
    // Public API
    // =========================================
    fp.home.init = () => {
        const homepageLink = document.querySelector('.homepage-link');
        if (homepageLink) homepageLink.classList.add('selected');

        lazyLoadSlideshow();
        sizeDetector();
        setupCarouselControls();
        setupVideoControls();
    };

})(window);